// Third-party
import React from 'react';
import { FormattedMessage } from 'react-intl';

// Components
import AddEnterpriseGroupMemberForm from '../forms/AddEnterpriseGroupMemberForm';
import EnterpriseGroup from '@/types/enterprise-group';
import EnterpriseAdminDetails from '@/types/enterprise-admin-details';
import Modal from '@/views/components/modals/AccessibleModal';

type Props = {
  show: boolean;
  group: EnterpriseGroup;
  adminDetails: EnterpriseAdminDetails;
  onCancel: () => void;
  onAdd: (memberID: string) => void;
};

const AddEnterpriseGroupMemberModal = (props: Props) => (
  <Modal show={props.show} className="add-enterprise-member-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>
        <FormattedMessage id="Admin.Enterprise.AddMember" />
      </Modal.Title>
    </Modal.Header>

    <Modal.Body className="d-flex flex-column">
      {props.group != null && (
        <AddEnterpriseGroupMemberForm onAddMember={props.onAdd} onCancel={props.onCancel} adminDetails={props.adminDetails} group={props.group} />
      )}
    </Modal.Body>
  </Modal>
);

export default AddEnterpriseGroupMemberModal;
